(function (global) {
    'use strict';

    global.MeloApps = global.MeloApps || {};

    /**
     * Composition root — single place to wire data source implementations.
     *
     * To use a real API later, replace MockMeloAppsRepository with:
     *   new MeloApps.HttpMeloAppsRepository('https://api.example.com')
     */
    var path = (global.location && global.location.pathname) || '';
    var isEnglish = path === '/en' || path.indexOf('/en/') === 0;
    var catalogs = global.MELO_APPS_CATALOG_BY_LOCALE || {};
    var catalog = (isEnglish && catalogs.en) ? catalogs.en : (catalogs.es || global.MELO_APPS_CATALOG);
    var repository = new global.MeloApps.MockMeloAppsRepository(catalog);
    var service = new global.MeloApps.MeloAppsService(repository);

    global.meloAppsService = service;
})(typeof window !== 'undefined' ? window : global);
